import * as yup from "yup"
import { Esemplare } from "../../types"

export function initialValuesEsemplare(esemplare?: Esemplare | undefined) {
  if (esemplare) {
    return esemplare
  }
  return {
    biblioteca: undefined,
    codice: "",
    consultato: false,
    digitalizzato: false,
    edizione: undefined,
    link: "",
    link_2: "",
    link_3: "",
    ordine: 0,
  }
}

export function validationSchemaEsemplare(showEdizione: boolean) {
  if (showEdizione) {
    return yup.object().shape({
      edizione: yup.number().required("Campo obbligatorio"),
      biblioteca: yup.number().required("Campo obbligatorio"),
      codice: yup.string().required("Campo obbligatorio"),
      // link: yup.string().url("Deve essere un URL valido"),
      ordine: yup.number().required("Campo obbligatorio"),
    })
  }
  return yup.object().shape({
    biblioteca: yup.number().required("Campo obbligatorio"),
    codice: yup.string().required("Campo obbligatorio"),
    // link: yup.string().url("Deve essere un URL valido"),
    ordine: yup.number().required("Campo obbligatorio"),
  })
}
